module.exports = __webpack_public_path__ + "media/photos/term-bg-8-6e4b3562.jpg";